// extracted by mini-css-extract-plugin
export default {"DetailOverview":"Update_DetailOverview__f-Ijg","Detail":"Update_Detail__C6BED"};